import { render, staticRenderFns } from "./pointInfo.vue?vue&type=template&id=319b9a6e&scoped=true&"
import script from "./pointInfo.vue?vue&type=script&lang=js&"
export * from "./pointInfo.vue?vue&type=script&lang=js&"
import style0 from "./pointInfo.vue?vue&type=style&index=0&id=319b9a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319b9a6e",
  null
  
)

export default component.exports